import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";

export function getHasAccessToLoggedOutInsiderMarketingPage(
  retailerCountry: keyof typeof ISO3166Alpha3 | undefined
) {
  const isAmerican = retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.USA;
  const isCanadian = retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN;
  const isAustralian =
    retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.AUS;

  return isAmerican || isCanadian || isAustralian;
}
